/* ANCHOR UX TEST 2026-10-09: behaviors for the new layouts. Cart calls go through
   window._anchorAddToCart / window._cartQty from theme.js (same Shopify AJAX cart). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function addToCart(id, qty) {
    if (window._anchorAddToCart) return window._anchorAddToCart(id, qty);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +id, quantity: qty }) }).then(function () { location.href = '/cart'; });
  }
  function busy(btn, label) {
    var orig = btn.getAttribute('data-label') || btn.innerHTML;
    btn.setAttribute('data-label', orig);
    btn.disabled = true; btn.innerHTML = label;
    return function (doneLabel) {
      btn.innerHTML = doneLabel || orig;
      setTimeout(function () { btn.innerHTML = btn.getAttribute('data-label'); btn.disabled = false; }, 1600);
    };
  }

  /* ---------- Header ---------- */
  var closeBtn = $('#uxMnavClose');
  if (closeBtn) closeBtn.addEventListener('click', function () { var h = $('#hamburger'); if (h) h.click(); });
  $$('.ux-nav__item > button').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var it = b.parentNode, open = !it.classList.contains('open');
      $$('.ux-nav__item.open').forEach(function (x) { x.classList.remove('open'); });
      it.classList.toggle('open', open); b.setAttribute('aria-expanded', open);
    });
  });
  document.addEventListener('click', function () { $$('.ux-nav__item.open').forEach(function (x) { x.classList.remove('open'); x.firstElementChild.setAttribute('aria-expanded', 'false'); }); });

  /* ---------- Product card add-to-cart (Shop All, home, related) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ux-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-ux-card]');
    var sel = card ? card.querySelector('select[data-ux-variant]') : null;
    var id = sel ? sel.value : btn.getAttribute('data-ux-add');
    var done = busy(btn, 'Adding...');
    addToCart(id, 1).then(function () { done('Added'); }).catch(function () { done('Try again'); });
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-ux-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex], card = sel.closest('[data-ux-card]');
    var img = card && card.querySelector('.ux-pcard__img img');
    if (img && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
  });

  /* ---------- Collection filter chips + sort ---------- */
  var grid = $('#uxCollectionGrid');
  if (grid) {
    var chips = $$('[data-ux-filter]');
    var countEl = $('#uxCount');
    var apply = function (cat) {
      if (!chips.some(function (c) { return c.getAttribute('data-ux-filter') === cat; })) cat = 'all';
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-ux-filter') === cat ? 'true' : 'false'); });
      var n = 0;
      $$('[data-ux-card]', grid).forEach(function (card) {
        var show = cat === 'all' || card.getAttribute('data-cat') === cat;
        card.classList.toggle('is-hidden', !show); if (show) n++;
      });
      if (countEl) countEl.textContent = n + (n === 1 ? ' product' : ' products');
    };
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var cat = c.getAttribute('data-ux-filter');
        history.replaceState(null, '', cat === 'all' ? location.pathname + location.search : '#' + cat);
        apply(cat);
      });
    });
    window.addEventListener('hashchange', function () { apply(location.hash.slice(1) || 'all'); });
    apply(location.hash.slice(1) || 'all');
    var sort = $('#uxSort');
    if (sort) sort.addEventListener('change', function () {
      var cards = $$('[data-ux-card]', grid), v = sort.value;
      cards.sort(function (a, b) {
        if (v === 'price-asc') return a.dataset.price - b.dataset.price;
        if (v === 'price-desc') return b.dataset.price - a.dataset.price;
        if (v === 'name') return a.dataset.name.localeCompare(b.dataset.name);
        return a.dataset.pos - b.dataset.pos;
      }).forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ---------- PDP ---------- */
  var pdp = $('[data-ux-pdp]');
  if (pdp) {
    var main = $('#uxMainImg', pdp);
    var thumbs = function () { return $$('.ux-thumb', pdp).filter(function (t) { return !t.hidden; }); };
    var show = function (t) {
      if (!t) return;
      $$('.ux-thumb', pdp).forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      main.style.opacity = '0.3';
      var src = t.getAttribute('data-full');
      var im = new Image(); im.onload = function () { main.src = src; main.style.opacity = '1'; }; im.src = src;
    };
    $$('.ux-thumb', pdp).forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
    var step = function (d) { var list = thumbs(), i = list.indexOf($('.ux-thumb.active', pdp)); show(list[(i + d + list.length) % list.length]); };
    $$('[data-ux-step]', pdp).forEach(function (b) { b.addEventListener('click', function () { step(+b.getAttribute('data-ux-step')); }); });
    var sx = 0, gm = $('.ux-gallery__main', pdp);
    if (gm) {
      gm.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1); }, { passive: true });
    }
    var vInput = $('#uxVariantId', pdp), priceEl = $('#uxPrice', pdp), atc = $('#uxAtc', pdp), nameEl = $('#uxVariantName', pdp);
    var qty = $('#uxQty', pdp);
    var setAtcLabel = function () {
      var p = +(atc.getAttribute('data-price') || 0), q = Math.max(1, parseInt(qty.value, 10) || 1);
      var avail = atc.getAttribute('data-available') !== 'false';
      atc.disabled = !avail;
      atc.innerHTML = avail ? 'Add to cart <span aria-hidden="true">&middot;</span> ' + money(p * q) : 'Sold out';
      var st = $('#uxStickyAtc'); if (st) { st.disabled = !avail; st.textContent = avail ? 'Add to cart' : 'Sold out'; }
    };
    $$('.ux-swatch', pdp).forEach(function (sw) {
      sw.addEventListener('click', function () {
        $$('.ux-swatch', pdp).forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-pressed', 'false'); });
        sw.classList.add('active'); sw.setAttribute('aria-pressed', 'true');
        var id = sw.getAttribute('data-variant-id');
        vInput.value = id;
        if (nameEl) nameEl.textContent = sw.getAttribute('data-title');
        var p = +sw.getAttribute('data-price'), cmp = +(sw.getAttribute('data-compare') || 0);
        priceEl.innerHTML = money(p) + (cmp > p ? ' <s>' + money(cmp) + '</s>' : '');
        atc.setAttribute('data-price', p);
        atc.setAttribute('data-available', sw.getAttribute('data-available'));
        $$('.ux-thumb[data-variant]', pdp).forEach(function (t) { t.hidden = t.getAttribute('data-variant') !== id; });
        var vt = $('.ux-thumb[data-variant="' + id + '"]', pdp);
        if (vt) show(vt); else if (sw.getAttribute('data-img')) { main.src = sw.getAttribute('data-img'); }
        setAtcLabel();
        if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + id);
      });
    });
    $$('[data-ux-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { var v = (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-ux-qty')); qty.value = Math.min(50, Math.max(1, v)); setAtcLabel(); });
    });
    qty.addEventListener('input', setAtcLabel);
    atc.addEventListener('click', function () {
      var done = busy(atc, 'Adding...');
      addToCart(vInput.value, Math.max(1, parseInt(qty.value, 10) || 1)).then(function () { done('Added to cart'); }).catch(function () { done('Something went wrong. Try again.'); });
    });
    /* Sticky mobile add-to-cart (round 2):
       - shows ONLY when the inline Add to cart button is out of view because the shopper scrolled past it
         (IntersectionObserver for the in-view state, plus a scroll check because the observer does not fire
         again when the button jumps from "above the screen" to "below the screen" without crossing it),
       - hides while the cart drawer or the mobile menu is open,
       - adds the SELECTED variant and quantity from the buy box (never the first variant). */
    var sticky = $('.ux-sticky-atc');
    if (sticky) {
      var sb = $('#uxStickyAtc'), sInfo = $('[data-sticky-info]', sticky), sImg = $('img', sticky);
      var drawer = $('#cartDrawer'), mnav = $('.ux-mnav');
      var atcInView = true;
      var overlayOpen = function () { return (drawer && drawer.classList.contains('open')) || (mnav && mnav.classList.contains('open')); };
      var update = function () {
        var past = !atcInView && atc.getBoundingClientRect().bottom < 0;
        var on = past && !overlayOpen();
        sticky.classList.toggle('visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (sb) sb.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('ux-sticky-on', on);
      };
      window._uxStickyUpdate = update;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { atcInView = en[0].isIntersecting; update(); }).observe(atc);
      } else { atcInView = false; }
      var ticking = false;
      window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }, { passive: true });
      window.addEventListener('resize', update);
      if ('MutationObserver' in window) [drawer, mnav].forEach(function (el) { if (el) new MutationObserver(update).observe(el, { attributes: true, attributeFilter: ['class'] }); });
      var syncSticky = function () {
        var sel = $('.ux-swatch.active', pdp), q = Math.max(1, parseInt(qty.value, 10) || 1), p = +(atc.getAttribute('data-price') || 0);
        if (sInfo) sInfo.textContent = (sel ? sel.getAttribute('data-title') + ' · ' : '') + (q > 1 ? 'Qty ' + q + ' · ' : '') + money(p * q);
        if (sImg && sel && sel.getAttribute('data-img')) sImg.src = sel.getAttribute('data-img');
      };
      var origLabel = setAtcLabel;
      setAtcLabel = function () { origLabel(); syncSticky(); };
      qty.addEventListener('input', syncSticky);
      if (sb) sb.addEventListener('click', function () {
        var id = vInput.value, q = Math.max(1, parseInt(qty.value, 10) || 1);
        var done = busy(sb, 'Adding...');
        addToCart(id, q).then(function () { done('Added'); update(); }).catch(function () { done('Try again'); });
      });
      update();
    }
    setAtcLabel();
  }

  /* ---------- Cart page (AJAX qty/remove, falls back to form submit) ---------- */
  var cartPage = $('[data-ux-cartpage]');
  if (cartPage) {
    var change = function (key, q) {
      cartPage.classList.add('is-busy');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function () { location.reload(); })
        .catch(function () { location.href = '/cart/change?id=' + encodeURIComponent(key) + '&quantity=' + q; });
    };
    $$('[data-line-qty]', cartPage).forEach(function (b) {
      b.addEventListener('click', function () { var row = b.closest('[data-key]'); var cur = +row.getAttribute('data-qty'); change(row.getAttribute('data-key'), Math.max(0, cur + (+b.getAttribute('data-line-qty')))); });
    });
    $$('[data-line-remove]', cartPage).forEach(function (b) {
      b.addEventListener('click', function () { change(b.closest('[data-key]').getAttribute('data-key'), 0); });
    });
    $$('input[data-line-input]', cartPage).forEach(function (inp) {
      inp.addEventListener('change', function () { var row = inp.closest('[data-key]'); change(row.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0)); });
    });
    document.addEventListener('anchor:cart', function (e) {
      // drawer changed the cart while on /cart: keep the page in sync
      var c = e.detail; if (c && c.item_count !== +cartPage.getAttribute('data-count')) location.reload();
    });
  }

  /* ---------- Help page FAQ search ----------
     Every typed word must appear in the question or answer (any order). Trailing "s" is ignored so
     "returns" finds "return" and "bundles" finds "bundle". Matching answers open, the rest hide. */
  var STOP = ['the', 'and', 'to', 'do', 'does', 'is', 'my', 'me', 'how', 'what', 'when', 'where', 'can', 'are', 'for', 'of', 'in', 'on', 'it', 'you', 'your', 'an', 'with', 'will', 'get', 'need', 'want', 'have', 'about', 'any', 'there'];
  var hs = $('#uxHelpSearch');
  if (hs) hs.addEventListener('input', function () {
    var words = hs.value.toLowerCase().replace(/[^a-z0-9$ ]+/g, ' ').split(/\s+/).filter(function (w) { return w.length > 1 && STOP.indexOf(w) < 0; })
      .map(function (w) { return w.length > 3 ? w.replace(/(es|s)$/, '') : w; });
    $$('[data-faq]').forEach(function (d) {
      var t = d.textContent.toLowerCase();
      var hit = !words.length || words.every(function (w) { return t.indexOf(w) > -1; });
      d.style.display = hit ? '' : 'none';
      d.open = !!(words.length && hit);
    });
  });
})();

/* ---------- Product rail arrows + dots (home "Popular right now") ---------- */
(function () {
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-rail-track]');
    var sec = rail.closest('section') || document;
    var prev = sec.querySelector('[data-rail-prev]'), next = sec.querySelector('[data-rail-next]');
    var dotsEl = rail.querySelector('[data-rail-dots]');
    if (!track) return;
    var pages = function () { return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth)); };
    var buildDots = function () {
      if (!dotsEl) return; dotsEl.innerHTML = '';
      for (var i = 0; i < pages(); i++) (function (i) {
        var b = document.createElement('button'); b.type = 'button'; b.tabIndex = -1;
        b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
        dotsEl.appendChild(b);
      })(i);
    };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dotsEl) {
        var n = dotsEl.children.length, idx = track.scrollLeft >= max ? n - 1 : Math.round(track.scrollLeft / track.clientWidth);
        Array.prototype.forEach.call(dotsEl.children, function (d, i) { d.classList.toggle('is-on', i === idx); });
      }
    };
    var step = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' }); };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); update(); });
    buildDots(); update();
  });
})();
